<template>
  <div class="rich-list-items">
    <div  v-for="item in items" :key="item.title + 1">
      <div class="rich-list" v-if="item?.title && item?.subtitle">
        <h4 v-if="item.title" class="rich-list-title"><VueMarkdown :source="item.title" /></h4>
        <div v-if="item.subtitle" class="rich-list-subtitle"><VueMarkdown :source="item.subtitle" /></div>
        <p v-if="item.event && item.event.name">Event: {{ item.event.name }}</p>
        <img v-if="item.image" class="rich-list-item-image" :src="item.image.imageUri" :alt="item.image.title">
      </div>
  </div>
  </div>
</template>

<script>
import VueMarkdown from 'vue-markdown-render'

export default {
  name: 'RichTypeList',
  components: { VueMarkdown },
  props: {
    items: {
      type: Array,
      default: () => ([])
    }
  }
}
</script>

<style lang="sass" scoped>
.rich-list-items
  display: flex
  flex-direction: column

.rich-list
  //padding: 8px
  //margin: 8px
  //border-radius: 8px
  //background-color: var(--background-component)
  //box-shadow: var(--shadow)
  justify-content: flex-start
  align-items: flex-start
  display: flex
  flex-direction: column

.rich-list-title
  font-size: 16px
  line-height: 20px
  margin: 0
  color: var(--text-title)

.rich-list-subtitle
  line-height: 20px
  font-size: 12px
  color: var(--text-subtitle)
</style>
